// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ElementOperand, ElementOperandT, verifyElementOperand } from "./element-operand";
import { FilterOperand, unionToFilterOperand, unionListToFilterOperand } from "./filter-operand";
import { LiteralOperand, LiteralOperandT, verifyLiteralOperand } from "./literal-operand";
import {
  SimpleAttributeOperand,
  SimpleAttributeOperandT,
  verifySimpleAttributeOperand,
} from "./simple-attribute-operand";

/**
 * Wraps a `FilterOperand` union so it can be stored in a vector.
 */
export class FilterOperandHolder implements flatbuffers.IUnpackableObject<FilterOperandHolderT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): FilterOperandHolder {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFilterOperandHolder(
    bb: flatbuffers.ByteBuffer,
    obj?: FilterOperandHolder,
  ): FilterOperandHolder {
    return (obj || new FilterOperandHolder()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsFilterOperandHolder(
    bb: flatbuffers.ByteBuffer,
    obj?: FilterOperandHolder,
  ): FilterOperandHolder {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new FilterOperandHolder()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  operandType(): FilterOperand {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : FilterOperand.NONE;
  }

  operand<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startFilterOperandHolder(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addOperandType(builder: flatbuffers.Builder, operandType: FilterOperand) {
    builder.addFieldInt8(0, operandType, FilterOperand.NONE);
  }

  static addOperand(builder: flatbuffers.Builder, operandOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, operandOffset, 0);
  }

  static endFilterOperandHolder(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // operand
    return offset;
  }

  static createFilterOperandHolder(
    builder: flatbuffers.Builder,
    operandType: FilterOperand,
    operandOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    FilterOperandHolder.startFilterOperandHolder(builder);
    FilterOperandHolder.addOperandType(builder, operandType);
    FilterOperandHolder.addOperand(builder, operandOffset);
    return FilterOperandHolder.endFilterOperandHolder(builder);
  }

  unpack(): FilterOperandHolderT {
    return new FilterOperandHolderT(
      this.operandType(),
      (() => {
        const temp = unionToFilterOperand(this.operandType(), this.operand.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: FilterOperandHolderT): void {
    _o.operandType = this.operandType();
    _o.operand = (() => {
      const temp = unionToFilterOperand(this.operandType(), this.operand.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): FilterOperandHolderT {
    const t = new FilterOperandHolderT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("operand_type")) {
      t.operandType = this.operandType();
    }
    if (fieldSet.has("operand")) {
      t.operand = (() => {
        const temp = unionToFilterOperand(this.operandType(), this.operand.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class FilterOperandHolderT implements flatbuffers.IGeneratedObject {
  constructor(
    public operandType: FilterOperand = FilterOperand.NONE,
    public operand: ElementOperandT | LiteralOperandT | SimpleAttributeOperandT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.operand === null || this.operand === undefined) {
      throw new Error('Required field "operand" is not set');
    }
    const operand = builder.createObjectOffset(this.operand);

    return FilterOperandHolder.createFilterOperandHolder(builder, this.operandType, operand);
  }

  clone(): FilterOperandHolderT {
    const obj = new FilterOperandHolderT();
    obj.operandType = this.operandType;
    obj.operand =
      this.operand !== null && typeof (this.operand as any).clone === "function"
        ? (this.operand as any).clone()
        : this.operand;
    return obj;
  }

  equals(other: FilterOperandHolderT): boolean {
    if (this.operandType !== other.operandType) return false;
    if (this.operand !== null && other.operand !== null) {
      if (typeof (this.operand as any).equals === "function") {
        if (!(this.operand as any).equals(other.operand)) return false;
      } else if (this.operand !== other.operand) return false;
    } else if (this.operand !== other.operand) return false;
    return true;
  }
}

export function verifyFilterOperandHolder(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "operand");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // LiteralOperand
            {
              const o = verifier.readInt32(pos);
              verifyLiteralOperand(verifier, pos + o);
            }
            break;
          case 2: // SimpleAttributeOperand
            {
              const o = verifier.readInt32(pos);
              verifySimpleAttributeOperand(verifier, pos + o);
            }
            break;
          case 3: // ElementOperand
            {
              const o = verifier.readInt32(pos);
              verifyElementOperand(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "operand");
  } finally {
    verifier.popDepth();
  }
}
